import { render, staticRenderFns } from "./tabela-planilha.vue?vue&type=template&id=8cca00e6&"
import script from "./tabela-planilha.vue?vue&type=script&lang=js&"
export * from "./tabela-planilha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSimpleTable,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cca00e6')) {
      api.createRecord('8cca00e6', component.options)
    } else {
      api.reload('8cca00e6', component.options)
    }
    module.hot.accept("./tabela-planilha.vue?vue&type=template&id=8cca00e6&", function () {
      api.rerender('8cca00e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabela-planilha.vue"
export default component.exports